import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';

@Injectable({
  providedIn: 'root'
})
export class RadarClienteService extends ApiConfig {
  constructor(private http: HttpClient) {
    super();
  }

 
  listarIdSelecionadoPorRadar(idRadar) {
    return new Promise(async (resolve) => {
      this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/RadarCliente/ListarIdSelecionadoPorRadar?idRadar=' + idRadar)
        .subscribe(data => {
          resolve(data);
        }, error => {

        });
    });
  }
  
  alterar(Cliente) {
    return new Promise(async (resolve) => {
      this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/RadarCliente/Atualizar', Cliente)
        .subscribe(data => {
          resolve(data);
        }, error => {


        });
    });
  }
  deletar(membro) {
    return new Promise(async (resolve) => {
      this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/RadarCliente/deletar', membro)
        .subscribe(data => {
          resolve(data);
        }, error => {
        });
    });
  }
  inserir(Cliente) {
    return new Promise(async (resolve) => {
      this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/RadarCliente/Inserir', Cliente)
        .subscribe(data => {
          resolve(data);
        }, error => {


        });
    });
  }
}
